import { Part } from '@/Engine/Wardrobe/Part';
import { moduleItem, sides, wardrobeTemplates } from '@/Interfaces/common';
import { defaultPerforatedPanelsOffsets } from '@/Constants/perforatedPanels';
import { V3dTools } from '@/v3d/common';
import { Group, Quaternion, Ray, Vector3 } from 'three';
import { IV3D } from '@/Interfaces/v3d';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { clearSeed, getRandomItem } from '@/lib/math';
import { $ } from '@/Engine/state';
import { Wardrobe } from '@/Engine/Wardrobe/Wardrobe';
import { ShelfAndPanel } from '@/Engine/Wardrobe/ShelfAndPanel';

declare let v3d: IV3D;
export interface perforatedPanelProps extends moduleItem {
    v3dTools: V3dTools;
    parent: Wardrobe;
    rackModule: RackModule;
}
export class PerforatedPanel extends ShelfAndPanel {
    _model: Part | null = null;
    templates: wardrobeTemplates;
    rackModule?: RackModule;

    get raw(): moduleItem {
        return {
            uuid: this.uuid,
            templates: this.templates,
            width: this.width,
            height: this.height,
            depth: this.depth,
            type: 'panel',
            place: this.place ?? 0,
            humanName: this.humanName,
            position: this.position.toArray(),
            rackModuleUUID: this.rackModule?.uuid,
            side: this.side,
            color: this.color,
        };
    }

    constructor(props: perforatedPanelProps) {
        super({ ...props,
            place: 0,
            type: 'panel',
            width: (props.compatibilityWidth?props.compatibilityWidth/100:props.width) });
        this.templates = props.templates;
        if (!props.templates.panel) return;
        const obj3d = this.v3dTools.getObjectByName(props.templates.panel.name);
        if (obj3d) {
            this._model = new Part({
                model: obj3d,
                offsets: [ ...defaultPerforatedPanelsOffsets ],
                ...props.templates.panel,
                side: this.side,
            });
            this._model.childPosition = [
                0,
                -this.height/2,
                this.depth + 0.005,
            ];
            this.model.add(this._model.model);
        } else {
            console.error('model name ' + props.templates.panel.name + ' is undefined');
        }

        this.startPoint = [
            - this.width / 2,
            - this.height - 0.01,
            - this.depth + 0.005,
        ];
    }

    checkCollisions() {
        const error = 0.01;
        const collisions = $.checkAllShelfCollisionWithExclude(this, this.side, []);
        collisions.forEach((collision)=> {
            if (collision.type === 'box') {
                this._model?.redMark();
            }
            if ([ 'panel', 'shelf' ].includes(collision.type)) {
                const firstShelfDeltaX = Math.abs(this.position.x - collision.position.x);
                const firstShelfWidthSum = this.width/2 + collision.width/2;
                const firstOnSameRack = Math.abs(this.position.x - collision.position.x) < error;
                let firstOverlay =
                    firstShelfDeltaX < firstShelfWidthSum - error || firstOnSameRack;
                if (collision.type === 'panel')
                    firstOverlay = firstOverlay && Math.abs(this.place - collision.place) < 12;
                if (firstOverlay)
                    this._model?.redMark();
            }
        });
    }

    _updateBox() {
        this.box.makeEmpty();
        this.decorModel.removeFromParent();
        const quart = new Quaternion();
        this.model.getWorldQuaternion(quart);
        this.box.setFromPoints([
            new Vector3(-this.width/2, -this.height/2, -this.depth/2 + 0.01).applyQuaternion(quart),
            new Vector3(this.width/2, this.height/2, this.depth/2 + 0.01).applyQuaternion(quart),
        ]);
        this.model.add(this.decorModel);
    }

    setColor(hex: string) {
        this.color = hex.replace('#','');
        if (this._model)
            this._model.setColor(hex);
    }

    clearDecor() {
        this._model?.clearDecor();
    }

    addDecor() {
        const decors = $.decorModelsBySurface;
        console.log($.decorModelsBySurface);
        this._model?.clearDecor();
        clearSeed(this.uuid);
        if (this._model) {
            const decor = this.getDecor(decors, 'punch_panels');
            if (decor) {
                this._model.decorModel.add(decor.model.clone());
                this._model.decorModel.position.set(...this._model.childPosition);
            }
        }
    }

    computeObb() {
        this.worldBox = this.box.clone().applyMatrix4(this.model.matrixWorld);
        const worldQuaternion = new Quaternion();
        this.model.getWorldQuaternion(worldQuaternion);
        const sizes = new Vector3();
        this.box.getSize(sizes);
        sizes.applyQuaternion(worldQuaternion);
        const shift = new Vector3(0,-Math.abs(sizes.y/2), -0.005).applyQuaternion(worldQuaternion);
        super.computeObb(shift);
    }


}
